import Vue from "vue";
import Router from "vue-router";
import Project from "./views/Project.vue";
import Tag from "./views/Tag.vue";
import Tier1 from "./views/Tier1.vue";
import Today from "./views/Today.vue";
import NewProjects from "./views/NewProjects.vue";
import Search from "./views/Search.vue";
import AllTags from "./views/AllTags.vue";
import ArchivedTags from "./views/ArchivedTags.vue";
import AllContacts from "./views/AllContacts.vue";
import AllProjects from "./views/AllProjects.vue";
import ArchivedProjects from "./views/ArchivedProjects.vue";
import ArchivedContacts from "./views/ArchivedContacts.vue"
import All from "./views/All.vue";
import Arrays from "./views/Arrays.vue";
import Inbox from "./views/Inbox.vue";
import Gmail from "./views/Gmail.vue";
import Calendar from "./views/Calendar.vue";
import LogBook from "./views/LogBook.vue";
import Trash from "./views/Trash.vue";
import Journal from "./views/Journal.vue";
import CompletedTasks from "./views/CompletedTasks.vue";
import CompletedTasksByProject from "./views/CompletedTasksByProject.vue";
import ContactCompletedTasks from "./views/ContactCompletedTasks.vue";
import TagCompletedTasks from "./views/TagCompletedTasks.vue";
import ProjectJournal from "./views/ProjectJournal.vue";
import ContactJournal from "./views/ContactJournal.vue";
import TagJournal from "./views/TagJournal.vue";
import Todo from "./views/Todo.vue";
import Contact from "./views/Contact.vue";
import FileCabinet from "./views/FileCabinet.vue";
import FileCabinetManager from "./views/FileCabinetManager.vue";
import Categories from "./views/Categories.vue";
import Category from "./views/Category.vue";
import FastBootTask from "./views/FastBootTask.vue";

Vue.use(Router);

import en from "./locales/en.json";

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'inbox',
      path: "/inbox",
      component: Inbox
    },
    {
      name: 'gmail',
      path: "/gmail",
      component: Gmail
    },
    {
      name: 'essentials',
      path: "/essentials",
      component: Tier1,
      props: { tier1: 'essentials' }
    }, 
    {
      name: 'project_essentials',
      path: "/project_essentials",
      component: Tier1,
      props: { tier1: 'project_essentials' }
    },     
    {
      name: 'today',
      path: "/today",
      component: Today
    },
    {
      name: 'calendar',
      path: "/calendar",
      component: Calendar
    },
    {
      name: 'waiting',
      path: "/waiting",
      component: Tier1,
      props: { tier1: 'waiting' }
    },
    {
      name: 'someday',
      path: "/someday",
      component: Tier1,
      props: { tier1: 'someday' }
    },
    {
      name: 'in_process',
      path: "/in_process",
      component: Tier1,
      props: { tier1: 'in_process' }
    },  
    {
      name: 'all',
      path: "/all_items",
      component: All
    },
    {
      name: 'arrays',
      path: "/arrays",
      component: Arrays
    },
    {
      name: 'logbook',
      path: "/logbook",
      component: LogBook
    },
    {
      name: 'trash',
      path: "/trash",
      component: Trash
    },
    {
      name: 'journal',
      path: "/journal",
      component: Journal
    },
    {
      name: 'completed_tasks',
      path: "/completed_tasks",
      component: CompletedTasks
    },
    {
      name: 'completed_tasks_by_project',
      path: "/completed_tasks_by_project",
      component: CompletedTasksByProject
    },
    {
      name: 'contact_completed_tasks',
      path: "/contact_completed_tasks",
      component: ContactCompletedTasks
    },
    {
      name: 'tag_completed_tasks',
      path: "/activity_completed_tasks",
      component: TagCompletedTasks
    },
    {
      name: 'new_projects',
      path: "/new_projects",
      component: NewProjects
    },              
    {
      name: 'search',
      path: "/search",
      component: Search
    },
    {
      name: 'project_journal',
      path: "/project_journal",
      component: ProjectJournal
    },
    {
      name: 'contact_journal',
      path: "/assistant_journal",
      component: ContactJournal
    },
    {
      name: 'tag_journal',
      path: "/activity_journal",
      component: TagJournal
    },
    {
      name: 'project',
      path: en.projects.route + '/:id',
      component: Project
    },
    {
      name: 'file_cabinet',
      path: '/file_cabinets/:id',
      component: FileCabinet
    }, 
    {
      name: 'file_cabinet_manager',
      path: '/file_cabinets',
      component: FileCabinetManager
    },        
    {
      name: 'all_tags',
      path: en.tags.route,
      component: AllTags
    },
    {
      name: 'archived_tags',
      path: en.tags.archived_route,
      component: ArchivedTags
    },
    {
      name: 'all_contacts',
      path: en.contacts.route,
      component: AllContacts
    },
    {
      name: 'all_projects',
      path: en.projects.parent_route,
      component: AllProjects
    },
    {
      name: 'category',
      path: en.categories.route + '/:id',
      component: Category
    },
    {
      name: 'archived_projects',
      path: en.projects.archived_route,
      component: ArchivedProjects
    },
    {
      name: 'archived_contacts',
      path: en.contacts.archived_route,
      component: ArchivedContacts
    },
    {
      name: 'tags',
      path: en.tags.route + '/:tag_name',
      component: Tag
    },
    {
      name: 'todo',
      path: en.todos.route + '/:task_id',
      component: Todo
    },
    {
      name: 'contact',
      path: '/assistants/:contact_id',
      props: true,
      component: Contact
    },
    {
      name: 'categories',
      path: en.categories.route,
      component: Categories 
    },
    {
      name: 'default',
      path: '/',
      component: Today
    },
  ]
});
